import React, { useState, useEffect } from 'react';

import { PromoText } from 'apps/promo/components/common/promo-text/PromoText';

import { DropdownList, DropdownListHeader, DropdownListItem } from './styles';

const PromoCurrencyList = (props) => {
    const [selectedItemIndex, setSelectedItemIndex] = useState(null);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                setSelectedItemIndex((prevIndex) => {
                    const nextIndex = prevIndex === null ? 0 : Math.min(prevIndex + 1, props.currencies.length - 1);
                    return nextIndex;
                });
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                setSelectedItemIndex((prevIndex) => {
                    const nextIndex = prevIndex === null ? props.currencies.length - 1 : Math.max(prevIndex - 1, 0);
                    return nextIndex;
                });
            } else if (event.key === 'Enter' && selectedItemIndex !== null) {
                props.handleCurrencySelection(props.currencies[selectedItemIndex]);
            } else if (event.key === 'Escape') {
                props.toggleCurrencyList();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [selectedItemIndex, props.currencies]);

    const renderCurrencyListItems = (currencies) => {
        return currencies.map((currency, index) => {
            return (
                <DropdownListItem
                    key={currency.id}
                    onClick={() => props.handleCurrencySelection(currency)}
                    tabIndex={'0'}
                    $isSelected={index === selectedItemIndex}
                >
                    <PromoText variant="subheader" color="gray80">
                        {currency.name}
                    </PromoText>
                    <PromoText variant="subheader" color="gray40">
                        {currency.code}
                    </PromoText>
                </DropdownListItem>
            );
        });
    };

    return (
        <DropdownList>
            <DropdownListHeader>
                <PromoText color="gray40">{props.header}</PromoText>
            </DropdownListHeader>
            {renderCurrencyListItems(props.currencies)}
        </DropdownList>
    );
};

export default PromoCurrencyList;
